var selectPayUrl = 'v1/credit/accounts/manage-promotions/post-transaction/offers';
export var selectPayEnrollOfferUrl = 'v1/credit/accounts/manage-promotions/post-transaction/enroll-offer';
export default selectPayUrl;
//# sourceMappingURL=select-pay-api.js.map